import { isGetHook, isMutatorHook, isStore } from "./client.js";
import { atom } from "nanostores";
import { get, writable } from "svelte/store";
import { onDestroy } from "svelte";

//#region src/client/client.svelte.ts
function isReadable(value) {
	return typeof value === "object" && value !== null && "subscribe" in value;
}
function isCallable(value) {
	return typeof value === "function";
}
function readableToAtom(value) {
	const a = atom(get(value));
	value.subscribe((newVal) => {
		a.set(newVal);
	});
	return a;
}
function runeToAtom(value) {
	const a = atom(value());
	$effect(() => {
		a.set(value());
	});
	return a;
}
function createSvelteHook(hook) {
	return ({ path, query } = {}) => {
		const pathParams = {};
		const queryParams = {};
		for (const [key, value] of Object.entries(path ?? {})) {
			const v = value;
			if (isCallable(v)) pathParams[key] = runeToAtom(v);
			else pathParams[key] = isReadable(v) ? readableToAtom(v) : v;
		}
		for (const [key, value] of Object.entries(query ?? {})) {
			const v = value;
			if (isCallable(v)) queryParams[key] = runeToAtom(v);
			else queryParams[key] = isReadable(v) ? readableToAtom(v) : v;
		}
		const store = hook.store({
			path: pathParams,
			query: queryParams
		});
		const data = writable(void 0);
		const loading = writable(false);
		const error = writable(void 0);
		const unsubscribe = store.subscribe((updatedStoreValue) => {
			data.set(updatedStoreValue.data);
			loading.set(updatedStoreValue.loading);
			error.set(updatedStoreValue.error);
		});
		onDestroy(() => {
			unsubscribe();
		});
		return {
			data,
			loading,
			error
		};
	};
}
function createSvelteMutator(hook) {
	return () => {
		const data = writable(void 0);
		const loading = writable(void 0);
		const error = writable(void 0);
		const unsubscribe = hook.mutatorStore.subscribe((storeValue) => {
			data.set(storeValue.data);
			loading.set(storeValue.loading);
			error.set(storeValue.error);
		});
		onDestroy(() => {
			unsubscribe();
		});
		const mutate = async (args) => {
			const { body, path, query } = args;
			const pathParams = {};
			const queryParams = {};
			for (const [key, value] of Object.entries(path ?? {})) {
				const v = value;
				pathParams[key] = isReadable(v) ? readableToAtom(v) : v;
			}
			for (const [key, value] of Object.entries(query ?? {})) {
				const v = value;
				queryParams[key] = isReadable(v) ? readableToAtom(v) : v;
			}
			return hook.mutatorStore.mutate({
				body,
				path: pathParams,
				query: queryParams
			});
		};
		return {
			mutate,
			loading,
			error,
			data
		};
	};
}
function createSvelteStore(hook) {
	return hook.obj;
}
function useFragno(clientObj) {
	const result = {};
	for (const key in clientObj) {
		if (!Object.prototype.hasOwnProperty.call(clientObj, key)) continue;
		const hook = clientObj[key];
		if (isGetHook(hook)) result[key] = createSvelteHook(hook);
		else if (isMutatorHook(hook)) result[key] = createSvelteMutator(hook);
		else if (isStore(hook)) result[key] = createSvelteStore(hook);
		else result[key] = hook;
	}
	return result;
}

//#endregion
export { createSvelteStore, readableToAtom, runeToAtom, useFragno };
//# sourceMappingURL=client.svelte.js.map